import { makeStyles } from '@material-ui/core';
import styled from 'styled-components';

import { THEME } from '../../../../../constants';

export const ServiceStatusContainer = styled.div`
  flex-grow:2;
  padding: 0 10px;
  text-align: center;
  overflow: hidden;
`;

export const ServiceStatusText = styled.p`
  align-items: center;
  border: 1px solid ${props => props.color};
  border-radius: 12px;
  color: ${props => props.color};
  white-space: nowrap;
  display: flex;
  font-family: Montserrat;
  font-size: 14px;
  font-weight: 500;
  justify-content: center;
  letter-spacing: 0.5px;
  margin: 0;
  min-width: 88px;
`;

export const useServiceSummaryStyle = makeStyles(theme => ({
  root: {
    display            : 'grid',
    gridTemplateColumns: '30px minmax(200px, 1fr) 180px 180px auto',
    margin             : theme.spacing(0, 0, 5),
    alignItems         : 'center',
    overflowX          : 'auto',

    '& > span': {
      borderBottom: `1px solid ${THEME.lightGrey}`,
      padding     : theme.spacing(2),
      height      : '55px',

      '&:nth-child(1), &:nth-child(2), &:nth-child(3), &:nth-child(4)': {
        fontSize: '16px',
      },
    },
  },
  detailsButton: {
    borderRadius : '8px !important',
    fontFamily   : 'Montserrat !important',
    fontSize     : '14px !important',
    fontWeight   : '500 !important',
    lineHeight   : '1.14 !important',
    letterSpacing: '0.5px',
    margin       : 0,
  },
}));
